import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormHelperService } from '../../../helpers/form-helper.service';
import {
    DraftFacade,
    RouterFacade
} from '@classifieds-sell/state';
import { ValidatorPipe } from '@classifieds-sell/shared';
import { PropertyInformationSectionComponent } from '../property-information-section/property-information-section.component';

@Component({
    selector: 'property-features-section',
    templateUrl: './property-features-section.component.html',
    styleUrls: ['./property-features-section.component.scss'],
    standalone: false
})
export class PropertyFeaturesSectionComponent
    extends PropertyInformationSectionComponent
    implements OnInit, OnDestroy {

    @ViewChild('propertyFeaturesSectionForm')
    propertyFeaturesSectionForm: NgForm;

    constructor(
        route: ActivatedRoute,
        draftFacade: DraftFacade,
        routerFacade: RouterFacade,
        changeDetectorRef: ChangeDetectorRef,
        formHelperService: FormHelperService,
        validatorPipe: ValidatorPipe
    ) {
        super(route, draftFacade, routerFacade, changeDetectorRef, formHelperService, validatorPipe);
    }

    isValid(): boolean {
        this.formHelperService.validate(this.propertyFeaturesSectionForm);
        return this.formValidationWhenDisabled(true, this.propertyFeaturesSectionForm);
    }

    dirty(): boolean {
        return this.propertyFeaturesSectionForm.form.dirty;
    }
}
